import { CalendarClock, CreditCard, LayoutDashboard, Receipt, Settings } from "lucide-react";

export const dashboardNavItems = [
  { label: "Overview", path: "/dashboard", icon: LayoutDashboard, end: true },
  { label: "Schedule", path: "/dashboard/sessions", icon: CalendarClock },
  { label: "Membership", path: "/dashboard/membership", icon: CreditCard },
  { label: "Payment History", path: "/dashboard/payments", icon: Receipt },
  { label: "Settings", path: "/dashboard/settings", icon: Settings },
];
